<script setup>
import {computed, ref, watch} from "vue";
import {__} from "@/i18n/useLanguage.js";

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  },
  isFirst: {
    type: Boolean,
    default: false
  },
  expanded: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['navigate', 'toggle']);

const isExpanded = ref(props.expanded);
const hasChildren = computed(() => props.item?.descendants?.length > 0);

watch(() => props.expanded, (value) => {
  isExpanded.value = value;
});

function handleClick() {
  if (hasChildren.value) {
    const next = !isExpanded.value;
    isExpanded.value = next;
    emit('toggle', {
      id: props.item.id,
      expanded: next,
      depth: props.depth
    });
    return;
  }

  emit('navigate', {
    name: 'Category',
    params: {
      categoryId: props.item.id
    }
  });
}

function openOverview() {
  emit('navigate', {
    name: 'Category',
    params: {
      categoryId: props.item.id
    }
  });
}
</script>

<template>
  <div :class="props.isFirst ? '' : 'border-t border-stone-300'">
    <button
      class="mobile-branch-row"
      :class="depth > 0 ? 'mobile-branch-child' : ''"
      @click="handleClick"
    >
      <span class="text-left">{{ __(item.name, item.name_en) }}</span>
      <img
        v-if="hasChildren"
        src="/images/icons/chevron.svg"
        alt=""
        class="h-4 w-4 transition-transform duration-200"
        :class="isExpanded ? 'rotate-180' : 'rotate-90'"
      >
    </button>

    <div
      v-if="isExpanded && hasChildren"
      class="border-t border-stone-300"
    >
      <button
        class="mobile-branch-overview"
        @click="openOverview"
      >
        {{ $t("{name} 전체보기", {name: __(item.name, item.name_en)}) }}
      </button>
      <mobile-sidebar-category-branch
        v-for="(child, index) in item.descendants"
        :key="child.id"
        :item="child"
        :depth="depth + 1"
        :is-first="index === 0"
        :expanded="false"
        @navigate="payload => emit('navigate', payload)"
        @toggle="payload => emit('toggle', payload)"
      />
    </div>
  </div>
</template>

<style scoped>
.mobile-branch-row {
  @apply w-full flex items-center justify-between px-4 py-3 text-base font-medium text-stone-700;
}

.mobile-branch-child {
  @apply pl-8 text-sm font-normal text-stone-600;
}

.mobile-branch-overview {
  @apply w-full border-b border-stone-300 px-8 py-3 text-left text-sm font-medium text-stone-700;
}
</style>
